import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'María González',
    text: 'Los mejores productos de panadería que he probado. La calidad es excepcional y el servicio es cálido y profesional.',
    rating: 5
  }, {
    name: 'Carlos Rodríguez',
    text: 'Contratamos el catering para un evento empresarial y fue un éxito total. Todo estaba delicioso y la presentación impecable.',
    rating: 5
  }, {
    name: 'Laura Martínez',
    text: 'La mesa dulce para el cumpleaños de mi hija fue espectacular. Superó todas nuestras expectativas. Altamente recomendable.',
    rating: 5
  }, {
    name: 'Jorge Fernández',
    text: 'Productos frescos todos los días. Se nota la dedicación y el amor por lo que hacen. Son mi panadería favorita.',
    rating: 5
  }, {
    name: 'Ana Silva',
    text: 'Excelente atención y productos de primera calidad. Las medialunas son las mejores de la ciudad.',
    rating: 5
  }, {
    name: 'Roberto Pérez',
    text: 'Profesionalismo y calidad en cada detalle. Los recomiendo para cualquier evento o simplemente para disfrutar en casa.',
    rating: 5
  }];
  return <section className="py-20 bg-white" data-id="element-173">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-175">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-secondary-brown mb-4" data-id="element-176">
            Lo Que Dicen Nuestros Clientes
          </h2>
          <p className="text-lg text-secondary-brown-light" data-id="element-177">
            La satisfacción de nuestros clientes es nuestra mayor recompensa
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-178">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-secondary-cream p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow" data-id="element-179">
              <div className="flex mb-4" data-id="element-180">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="text-primary-yellow fill-current" size={20} data-id="element-181" />)}
              </div>
              <p className="text-secondary-brown-light mb-6 italic" data-id="element-182">
                "{testimonial.text}"
              </p>
              <p className="font-semibold text-secondary-brown" data-id="element-183">
                — {testimonial.name}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}